export const selectIsAuthenticated = (state) => state.app.user.logedIn;
export const selectCurrentUserId = (state) => state.app.user.me.id;
